const config = {
  apiUrl: process?.env?.REACT_APP_BASE_URL || "",
  PAGE_SIZE: 10,
};

export type GenericFn = (...args: any) => void;

export default config;
